<app-mobile-header [title]="title"></app-mobile-header>
<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 mt-4">
    @if(showError) {
      <div class="row">
        <div class="col-12">
          <div class="alert alert-danger text-center" role="alert">
            {{ errorMessage | translate }}
          </div>
        </div>
      </div>
    }
    @if(sessionInfo) {
      @if(sessionInfo.isClosed) {
        <app-pay-till-now-session-closed [sessionInfo]="sessionInfo" (downloadReceipt)="onDownloadReceipt()"></app-pay-till-now-session-closed>
      } @else {
        <app-pay-till-now-session-active [sessionInfo]="sessionInfo" (payNow)="onPayNow()"></app-pay-till-now-session-active>
      }
    }
  </div>
</div>
